import { ListItem, ListItemText, Skeleton } from '@mui/material';
import { ReactNode, useMemo } from 'react';

export function InfoPair({
  label,
  value,
  isLoading,
}: {
  label: string;
  value?: string | number | ReactNode | null;
  isLoading?: boolean;
}) {
  // Derive a stable, varied skeleton width from the label (pure — no Math.random in render).
  const randomWidthPercentage = useMemo(() => {
    let hash = 0;
    for (let i = 0; i < label.length; i++) {
      hash = (hash * 31 + label.charCodeAt(i)) | 0;
    }
    return (Math.abs(hash) % 40) + 20;
  }, [label]);
  return (
    <ListItem sx={{ px: 0, pb: 0.5 }}>
      <ListItemText
        secondary={label}
        primary={
          isLoading ? (
            <Skeleton width={`${randomWidthPercentage}%`} />
          ) : (
            value || 'N/A'
          )
        }
      />
    </ListItem>
  );
}
